<template>
  <div class="flex flex-col">
    <div
      :class="{
        flex: showLocationPanel,
        hidden: !showLocationPanel,
      }"
      class="absolute transition-all bottom-14 w-full h-18 text-white flex-col justify-start border-t border-zonnegrens-secondary"
      style="background-color: #000000a1;z-index: 9999;"
    >
      <div class="w-full p-4">
        <b-autocomplete
          id="search-input"
          field="display_name"
          dropdown-position="top"
          :autofocus="true"
          :data="geocodeResult"
          :loading="isGeocoding"
          placeholder="Zoek naar locatie"
          icon-right="magnify"
          @typing="doGeocode"
          @select="selectPlace"
        >
          <template slot="empty">
            {{ $t("SearchBar.empty") }}
          </template>
          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <b-icon 
                  icon="map-marker" 
                  size="is-small"
                />
              </div>
              <div class="media-content">
                <p class="has-text-left">
                  {{ props.option.place_name_nl }}
                  <br>
                  <small>
                    {{ typeOfFeature(props.option.place_type[0]) }}
                  </small>
                </p>
              </div>
            </div>
          </template>
        </b-autocomplete>
      </div>
    </div>
    <div
      :class="{
        grid: showTimePanel,
        hidden: !showTimePanel,
      }"
      class="grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-2 absolute transition-all bottom-14 w-full text-white justify-evenly items-center border-t border-zonnegrens-secondary"
      style="background-color: #000000a1;z-index: 9999;"
    >
      <div class="flex flex-col w-full px-2 justify-center">
        <div class="text-xs uppercase">
          {{ monthAsText }}
        </div>
        <div>
          <input
            id="month"
            v-model="month"
            class="w-full"
            type="range"
            name="month"
            max="12"
            min="1"
            step="1"
            @input="updateSun"
            @change="updateDatetime"
          >
        </div>
      </div>
      <div class="flex flex-col w-full  px-2">
        <div class="text-xs uppercase">
          Dag {{ day }}
        </div>
        <div>
          <input
            id="day"
            v-model="day"
            class="w-full"
            type="range"
            name="day"
            max="31"
            min="1"
            step="1"
            @input="updateSun"
            @change="updateDatetime"
          >
        </div>
      </div>
      <div class="flex flex-col w-full  px-2">
        <div class="text-xs uppercase">
          Uur {{ hour }}
        </div>
        <div>
          <input
            id="hour"
            v-model="hour"
            class="w-full"
            type="range"
            name="hour"
            max="23"
            min="0"
            step="1"
            @input="updateSun"
            @change="updateDatetime"
          >
        </div>
      </div>
      <div class="flex flex-col w-full  px-2">
        <div class="text-xs uppercase">
          Minuut {{ minute }}
        </div>
        <div>
          <input
            id="minute"
            v-model="minute"
            class="w-full"
            type="range"
            name="minute"
            max="59"
            min="0"
            step="1"
            @input="updateSun"
            @change="updateDatetime"
          >
        </div>
      </div>
    </div>
    <div
      class="top-menu absolute bottom-0 w-full h-14 flex items-center border-t border-zonnegrens-secondary overflow-y-auto"
      style="background-color: #000000a1;z-index: 9999;"
    >
      <div
        @click="redirectToAccount"
        class="mx-2 px-1 py-1 text-white w-10 md:w-32 h-10 font-medium flex justify-center items-center cursor-pointer text-xl transition-all flex-shrink-0"
        style="background-color:#117DFF;font-family:'Leckerli One','cursive';"
      >
        Z<span class="hidden md:block">onnegrens</span>
      </div>
      <div>
        <Compass
          ref="compass" 
          @orient-north="$emit('orient-north')"
        />
      </div>
      <div
        class="text-white flex flex-col px-4 w-32 flex-shrink-0 cursor-pointer"
        role="button"
        @click="toggleTimePanel"
      >
        <div class="text-xs text-white uppercase">
          Tijd
        </div>
        <div class="text-sm text-zonnegrens-secondary">
          {{ formattedDate }}
        </div>
      </div>

      <div
        class="text-white flex flex-row border-l border-zonnegrens-secondary h-full px-4 flex-shrink-0 cursor-pointer items-center"
        role="button"
        @click="toggleBackgroundMap"
      >
        <div class="flex justify-center items-center">
          <svg 
            class=""
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M2.50003 8.85964L11.5 14.0596C11.6521 14.1474 11.8245 14.1936 12 14.1936C12.1756 14.1936 12.348 14.1474 12.5 14.0596L21.5 8.85964C21.6512 8.77238 21.7768 8.64709 21.8646 8.49622C21.9523 8.34535 21.999 8.17415 22 7.99964C22.0007 7.82343 21.9549 7.65016 21.8671 7.49738C21.7792 7.34461 21.6526 7.21774 21.5 7.12964L12.5 1.93964C12.348 1.85187 12.1756 1.80566 12 1.80566C11.8245 1.80566 11.6521 1.85187 11.5 1.93964L2.50003 7.12964C2.34743 7.21774 2.22081 7.34461 2.13301 7.49738C2.04521 7.65016 1.99933 7.82343 2.00003 7.99964C2.00108 8.17415 2.04779 8.34535 2.13551 8.49622C2.22322 8.64709 2.34889 8.77238 2.50003 8.85964ZM12 3.99964L19 7.99964L12 11.9996L5.00003 7.99964L12 3.99964ZM20.5 11.1696L12 15.9996L3.50003 11.1296C3.3859 11.0635 3.25981 11.0206 3.12903 11.0035C2.99825 10.9863 2.86537 10.9951 2.73803 11.0295C2.61069 11.0639 2.49141 11.1232 2.38706 11.2038C2.28271 11.2845 2.19536 11.3851 2.13003 11.4996C1.99966 11.7293 1.96539 12.0011 2.03471 12.2559C2.10403 12.5107 2.2713 12.7277 2.50003 12.8596L11.5 18.0596C11.6521 18.1474 11.8245 18.1936 12 18.1936C12.1756 18.1936 12.348 18.1474 12.5 18.0596L21.5 12.8596C21.7288 12.7277 21.896 12.5107 21.9654 12.2559C22.0347 12.0011 22.0004 11.7293 21.87 11.4996C21.8047 11.3851 21.7173 11.2845 21.613 11.2038C21.5087 11.1232 21.3894 11.0639 21.262 11.0295C21.1347 10.9951 21.0018 10.9863 20.871 11.0035C20.7402 11.0206 20.6142 11.0635 20.5 11.1296V11.1696ZM20.5 15.1696L12 19.9996L3.50003 15.1296C3.3859 15.0635 3.25981 15.0206 3.12903 15.0035C2.99825 14.9863 2.86537 14.9951 2.73803 15.0295C2.61069 15.0639 2.49141 15.1232 2.38706 15.2038C2.28271 15.2845 2.19536 15.3851 2.13003 15.4996C1.99966 15.7293 1.96539 16.0011 2.03471 16.2559C2.10403 16.5107 2.2713 16.7277 2.50003 16.8596L11.5 22.0596C11.6521 22.1474 11.8245 22.1936 12 22.1936C12.1756 22.1936 12.348 22.1474 12.5 22.0596L21.5 16.8596C21.7288 16.7277 21.896 16.5107 21.9654 16.2559C22.0347 16.0011 22.0004 15.7293 21.87 15.4996C21.8047 15.3851 21.7173 15.2845 21.613 15.2038C21.5087 15.1232 21.3894 15.0639 21.262 15.0295C21.1347 14.9951 21.0018 14.9863 20.871 15.0035C20.7402 15.0206 20.6142 15.0635 20.5 15.1296V15.1696Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="hidden md:flex flex-col ml-2">
          <div class="text-xs text-white uppercase">
            Achtergrond
          </div>
          <div class="text-sm text-zonnegrens-secondary">
            <span v-if="showTopographicMap">Topografisch</span>
            <span v-else>Luchtfoto</span>
          </div>
        </div>
      </div>                 
    </div>
  </div>
</template>

<script>
import debounce from "debounce";
import Proj4 from "proj4";
import Compass from "@/components/Compass.vue";

Proj4.defs([
  [
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs",
  ],
  [
    "EPSG:4326",
    "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees",
  ],
]);

export default {
  name: "AppControls",
  components: {
    Compass,
  },

	props: {
		showBuildingInfo: {
			type: Boolean,
			default: false
		},
		building: {
			type: Object,
			default() {

				return {

					pz: 0,
					batchID: '-999'

				};

			}
		}
	},  
  data() {
    let now;
    let q = this.$router.currentRoute.query;
    if ("dt" in q) {
      // console.log("We got time!", q["dt"]);
      now = new Date(Number(q["dt"]));
    } else {
      const today = new Date();
      today.setHours(13);
      now = today;
    }
    
    return {
      geocodeResult: [],
      selectedGeocodeResult: null,
      isGeocoding: false,
      isModalActive: false,
      showTimePanel: true,
      showLocationPanel: false,
      showTopographicMap: true,
      minute: now.getMinutes(),
      hour: now.getHours(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
  },
  computed: {
		h_clicked: function () {
      console.log(this.building)
      if ( this.building && this.building.pz ) return this.building.pz.toFixed( 1 );
      return null;
    },
    azimuthAngle: function () {
      if ( this.building && this.building.azimuthAngle !== undefined ) {
        return this.building.azimuthAngle.toFixed( 1 );
      }
      return '-';
    },    
    activeGeocodeResult: function() {
      if (this.selectedGeocodeResult) {
        return this.selectedGeocodeResult.place_name_nl;
      }
      return "Klik hier"
    },
    date: function() {
      const _date = new Date();
      _date.setMinutes(this.minute);
      _date.setHours(this.hour);
      _date.setMonth(this.month - 1);
      _date.setDate(this.day);
      return _date;
    },
    formattedDate: function() {
      const _date = new Date();
      _date.setMinutes(this.minute);
      _date.setHours(this.hour);
      _date.setMonth(this.month - 1);
      _date.setDate(this.day);

      const month = _date.toLocaleDateString("nl-NL", {
        month: "2-digit",
      });
      const day = _date.toLocaleDateString("nl-NL", {
        day: "2-digit",
      });
      const hour = _date.toLocaleTimeString("nl-NL", {
        hour: "2-digit",
      });
      const minute = _date.toLocaleTimeString("nl-NL", {
        minute: "2-digit",
      });
      const minutePadded =
        String(Number(minute) < 10 ? "0" : "") + String(minute);
      return `${day}/${month} ${hour}:${minutePadded}`;
    },
    monthAsText: function() {
      const months = [
        "",
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December",
      ];
      return months[this.month];
    },
  },
  methods: {
    redirectToAccount: function() {
      window.location.href="https://www.zonnegrens.nl/";
    },
    typeOfFeature: function(type) {
      const types = [
        {"original": "municipality", "translation": "Gemeente"},
        {"original": "address", "translation": "Adres"},
        {"original": "place", "translation": "Plaats"},
        {"original": "locality", "translation": "Plaats"},
      ]
      const result = types.find(t => t.original === type);
      if (result) {
        return result.translation;
      }
      return type;
    },
    downloadImage: function() {
      this.$emit("download-image");
    },
    focusSearchBar: function() {
      document.getElementById("search-input").focus();
    },
    selectPlace: function(res) {
      this.selectedGeocodeResult = res;
      this.$emit("select-place", res);
      this.showLocationPanel = false;
      this.isModalActive = false;
    },
    doGeocode: debounce(function(name) {
      if (!name.length) {
        this.geocodeResult = [];
        return;
      }
      this.isGeocoding = true;
      fetch(`https://api.maptiler.com/geocoding/${name}.json?key=FU&language=nl&country=nl&types=address`)
        .then(res => {
          return res.json()
        })
        .catch(error => {
          this.geocodeResult = [];
          throw error;
        })
        .then(json => {
          // console.log("json", json);
          this.geocodeResult = json.features.map((a) => {
            let rd_coords = Proj4("EPSG:4326", "EPSG:28992", [
              parseFloat(a.center[0]),
              parseFloat(a.center[1]),
            ]);
            a.rd_x = rd_coords[0];
            a.rd_y = rd_coords[1];
            return a;
          });          
        })
        .catch((error) => {
          this.geocodeResult = [];
          throw error;
        })
        .finally(() => {
          this.isGeocoding = false;
        });        
    }, 300),
    doGeocodeNominatim: debounce(function(name) {
      if (!name.length) {
        this.geocodeResult = [];
        return;
      }
      this.isGeocoding = true;
      fetch(
        "https://nominatim.openstreetmap.org/search?q=" +
          name +
          "&format=json&countrycodes=nl&accept-language=nl"
      )
        .then((res) => {
          const contentType = res.headers.get("content-type");
          if (
            res.ok &&
            contentType &&
            contentType.indexOf("application/json") !== -1
          ) {
            return res.json();
          }
        })
        .catch((error) => {
          this.geocodeResult = [];
          throw error;
        })
        .then((json) => {
          this.geocodeResult = json.map((a) => {
            let rd_coords = Proj4("EPSG:4326", "EPSG:28992", [
              parseFloat(a.lon),
              parseFloat(a.lat),
            ]);
            a.rd_x = rd_coords[0];
            a.rd_y = rd_coords[1];
            return a;
          });
        })
        .catch((error) => {
          this.geocodeResult = [];
          throw error;
        })
        .finally(() => {
          this.isGeocoding = false;
        });
    }, 300),    
    updateSun() {
      this.$emit("update-sun", { date: this.date });
    },
    updateDatetime() {
      this.$emit("update-datetime", { date: this.date });
    },
    toggleBackgroundMap() {
      this.showTopographicMap = !this.showTopographicMap;
      if (this.showTopographicMap) {
        this.$emit("set-background-map", { type: "topographic" });
      } else {
        this.$emit("set-background-map", { type: "aerial" });
      }
    },
    toggleLocationPanel() {
      this.showTimePanel = false;
      this.showLocationPanel = !this.showLocationPanel;
    },
    toggleTimePanel() {
      this.showLocationPanel = false;
      this.showTimePanel = !this.showTimePanel;
    },
  },
};
</script>
